export default __webpack_public_path__ + "static/media/terms_and_conditions.dfa44a1c.pdf";